<template>
  <div id="Home" class="wrap">
    <!-- 16기 모집 팝업 -->
    <div id="popupModal" class="black-bg" v-if="popup == true" @click="close()" style="display:none;">
      <div class="white-bg">
        <div class="header">
          <b-icon icon="x" class="h2 mb-2" @click="close()"></b-icon>
        </div>
        <div class="body">
          <img
            src="../assets/poster/SEVS_16기모집.png"
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>
    <div id="sevs">
      <div class="row">
        <div class="logo">
          <div class="imgbox poster">
            <img src="@/assets/logo/SEVS로고.png" />
          </div>
        </div>
        <div class="text">
          <div class="intro">
            <!-- <div class="logo"><img src="@/assets/logo/SEVS로고.png"></div> -->
            <p class="txt">
              SEVS는 뉴미디어아트그룹 VERS에서 운영하는
              <span style="font-weight: 600; background: #00ab80; color: white"
                >미디어아트 전시 지원플랫폼</span
              >입니다. 미디어 기술의 발전과 미디어 아트에 대한 관심이 빠르게
              부상하고 있습니다. 이에 대한 지반을 넓히고 견고하게 하기 위한
              목적으로 VERS에서는 신진 미디어 아티스트 및 기획자를 위한 전시
              지원 프로그램을 운영합니다. 대규모 공간을 필요로 하는 미디어아트
              전시의 공간 지원과 높은 가격의 하드웨어 장비에 대해 지원합니다.
              프로젝션 맵핑, NFT, AR, VR 등 다양한 영상과 인터랙션을 주제로 하는
              세미나와 전시를 위한 제작 환경을 지원합니다. 2014년부터 시작된
              SEVS는 2022년 현재까지 15기, 150여명의 미디어아티스트들을
              지원하였습니다.
            </p>
          </div>
        </div>
        <!-- <div class="col-12 col-md-5">
                    <div class="imgbox poster"><img src="@/assets/poster/셉스포스터1.png"></div>
                </div> -->
      </div>
    </div>
    <!-- <div id="program"> -->
    <!-- <h2>프로그램</h2> -->
    <!-- <ul>
                <li>
                    <p>기획자 / 작가 모집</p>
                    <div class="line">
                        <span class="circle"></span>
                    </div>
                    <span class="date">3월</span>
                </li>
                <li>
                    <p>세미나 / 전시 작품 기획</p>
                    <div class="line">
                        <span class="circle"></span>
                    </div>
                    <span class="date">4월</span>
                </li>
                <li>
                    <p>미디어아트 전시 제작</p>
                    <div class="line">
                        <span class="circle"></span>
                    </div>
                    <span class="date">6월</span>
                </li>
                <li>
                    <p>전시</p>
                    <div class="line">
                        <span class="circle"></span>
                    </div>
                    <span class="date">10월</span>
                </li>
                <li>
                    <p>아카이빙</p>
                    <div class="line">
                        <span class="circle"></span>
                    </div>
                    <span class="date">11월</span>
                </li>
                <li>
                    <div class="line">
                        <span class="circle"></span>
                    </div>
                    <span class="date">12월</span>
                </li>
            </ul>  -->
    <!-- <img src="@/assets/image/프로그램.png" /> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      popup: true,
    };
  },
  methods: {
    close() {
      this.popup = false;
    },
  },
};
</script>

<style lang="scss">
#Home {
  min-height: calc(100vh - 217.5px) !important;
  #sevs {
    padding: 80px 0 70px;
    position: relative;
    .row {
      margin-top: 54px;
      .logo {
        width: 30%;
        margin: 25px 0 40px 0;
        img {
          width: 70%;
        }
      }
      .txt {
        font-size: 23.5px;
        line-height: 1.9;
        text-align: justify;
        word-spacing: 2px;
        letter-spacing: 1px;
      }
    }
    .poster {
      width: 90%;
      img {
        width: 100%;
      }
    }
  }
  #program {
    img {
      width: 120%;
      margin-left: -9%;
    }
    // ul{padding:1rem 0 6rem 0; width: 100%; text-align: center;
    //     li{display:inline-block; text-align:left;}
    //         li:nth-child(1){width: 10%;}
    //         li:nth-child(2){width: 23%;}
    //         li:nth-child(3){width: 37%;}
    //         li:nth-child(4){width: 10%;}
    //         li:nth-child(5){width: 10%;}
    //         li:nth-child(6){width: 10%;}
    //         li:last-child{width: 40px;}
    //         li:last-child .line{border-bottom: 0;}
    //         li:last-child span.date{transform: translate(-1vw);}
    //         p{font-size:1rem; width:100%; margin-left:7px; text-align:center; margin-bottom:1rem; line-height: 1.4; font-weight: 400;}
    //         .line{width:100%; border-bottom:2px solid black; position: relative;
    //             .circle{display:block; width:15px; height:15px; background:white; border:1px solid rgb(0, 0, 0); border-radius: 2rem; margin-bottom:-8px; box-shadow: 0px 0px 5px 3px gray;}
    //         }
    // .date{font-size: 1.1rem; margin-top: 1.6rem; display: block; width: 100%; font-weight: 300; margin-left: -10px;}
    // }
    // .row {
    //     .textbox{line-height: 2.1; text-align: left; margin-bottom: 5%;
    //         h4{font-weight: 500;}
    //         table{margin: 1.3%; font-size: 20px;}
    //         h5{font-weight: 300; margin-top: 3%;}
    //         span{color:#fb4343; font-size: 25px; font-weight: 600;}

    //    .img{ margin-top: 5%;
    //         img{width: 32%; height: 270px; overflow: hidden; float: left; }
    //         }
    //     }
    // }
  }
  .black-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    padding: 20px;
    z-index: 9999;
    top: 30px;
    left: 10%;
    .white-bg {
      width: 480px;
      height: 670px;
      background: white;
      border-radius: 5px;
      padding: 10px 15px;
      border: 1px solid #9b9b9b;
      .header {
        width: 100%;
        height: 40px;
        .b-icon {
          float: right;
          cursor: pointer;
        }
      }
      .body {
        border: 1px solid black;
      }
    }
  }
}
@media (max-width: 767px) {
  #Home {
    padding: 0 10px;
    #sevs {
      padding-top: 1px;
      padding-bottom: 0px;
      .row {
        .logo {
          width: 50%;
          margin-bottom: 20px;
        }
      }
      .text {
        .txt {
          font-size: 17px;
        }
      }
    }
    #program {
      padding-top: 10px;
      white-space: nowrap;
      overflow-x: scroll;
      img {
        margin-left: -16%;
        height: 310px;
        width: 1000px;
      }

      //     h2{margin-bottom: 0;}
      //     ul{width: 100%; overflow-x:scroll; white-space: nowrap; padding: 2rem 10px 3rem 10px;
      //         li{display:inline-block; text-align:left;}
      //             li:nth-child(1){width: 18vw;}
      //             li:nth-child(2){width: 40vw;}
      //             li:nth-child(3){width: 32vw;}
      //             li:nth-child(4){width: 50vw;}
      //             li:nth-child(5){width: 18vw;}
      //             li:nth-child(6){width: 18vw;}
      //             li:last-child{width: 40px;}
      //             li:last-child .line{border-bottom: 0;}
      //             p{font-size: .8rem; width: 100%; white-space: normal; text-align: center; vertical-align: top;}
      //             .line{width: 100%; border-bottom: 1px solid black; position: relative;}

      //     }

      //     .row{
      //         .photo{
      //             img{margin-left: 20px; margin-bottom: 30px;}
      //         }
      //         .textbox{ padding: 0;
      //             table{margin:10px 0px 10px 0px;}
      //             tr{font-size: 16.5px;}
      //             p{font-size: 0.9rem;}
      //             h5{font-size: 13px;}
      //             .img{
      //                 img{width: 29%; height: 70px; float: left; overflow: hidden;}
      //             }
      //         }
      //     }
    }
    .black-bg {
      position: fixed;
      width: 100%;
      height: 100%;
      padding: 20px;
      z-index: 9999;
      left: 3px;
      .white-bg {
        width: 300px;
        height: 428px;
        background: white;
        border-radius: 5px;
        padding: 10px 15px;
        border: 1px solid #9b9b9b;
        .header {
          width: 100%;
          height: 40px;
          .b-icon {
            float: right;
            cursor: pointer;
          }
        }
        .body {
          border: 1px solid black;
        }
      }
    }
  }
}
</style>
